<template>
	<div>
		<!-- Adresse -->
		<div style="display: flex; flex-direction: column">
			<IconText
				:icon="locationIcon"
				:text="address"
				icon-color="red"
			/>

			<!-- Adresse additionnelle -->
			<small
				v-if="addressAdditional"
				style="margin-left: 1.8rem;"
			>
				{{ addressAdditional }}
			</small>
		</div>
	</div>
</template>

<script lang="ts">
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { mdiMapMarker } from '@mdi/js';
	import IconText from '@/components/search-psychologist/result-section/card-content/IconText.vue';

	/**
	 * Gère l'affichage de l'adresse d'un psychologue
	 */
	@Component({
		components: { IconText }
	})
	export default class Address extends Vue {
		// Adresse
		@Prop({ default: '' })
		readonly address!: string;

		// Information additionnelle
		@Prop({ default: '' })
		readonly addressAdditional?: string;

		// Icone de localisation
		readonly locationIcon = mdiMapMarker;
	}
</script>

<style lang="css" scoped>
p {
	margin: 0 !important;
}
</style>
